import { useRef } from "react";
import { Button, Card, Col, Row } from "react-bootstrap";
import about3 from "../assets/images/about3.jpg";
import about4 from "../assets/images/about4.jpeg";
import { motion, useInView } from "framer-motion";
import { ReactComponent as MobileIcon } from "../assets/images/mobile.svg";
import { ReactComponent as DesignIcon } from "../assets/images/web-design.svg";
import { ReactComponent as WebIcon } from "../assets/images/web-coding.svg";
import html from "../assets/images/html-5.svg";
import css from "../assets/images/css-3.svg";
import javascript from "../assets/images/js.svg";
import java from "../assets/images/java.svg";
import react from "../assets/images/react.svg";
import photoshop from "../assets/images/photoshop.svg";
import figma from "../assets/images/figma.svg";
import aws from "../assets/images/aws.svg";
import mongo from "../assets/images/mongodb.svg";
import kotlin from "../assets/images/kotlin.svg";
import android from "../assets/images/android.svg";
import node from "../assets/images/node-js.svg";
import mission from "../assets/images/abc.jpg";
import { useNavigate } from "react-router-dom";

function Homecontent() {
  const cardVariant = {
    hidden: { opacity: 0, x: -100 },
    visible: (i) => ({
      opacity: 1,
      x: 0,
      transition: { delay: i * 0.6, duration: 1, type: "tween" },
    }),
  };
  const cardVariant2 = {
    hidden: { opacity: 0, y: 100 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.2, // faster stagger
        duration: 0.5, // faster animation
        type: "tween",
      },
    }),
  };
 const navigate = useNavigate();

  const aboutImagesRef = useRef(null);
  const aboutTextRef = useRef(null);
  const servicesRef = useRef(null);
  const contactRef = useRef(null);
  const techRef = useRef(null);
  const missonRef = useRef(null);

  // Check if elements are in view
  const aboutImagesInView = useInView(aboutImagesRef, {
    once: true,
    amount: 0.3,
  });
  const aboutTextInView = useInView(aboutTextRef, { once: true, amount: 0.3 });
  const servicesInView = useInView(servicesRef, { once: true, amount: 0.2 });
  const contactInView = useInView(contactRef, { once: true, amount: 0.5 });
  const tchInView = useInView(techRef, { once: true, amount: 0.5 });
  const missionInView = useInView(missonRef, { once: true, amount: 0.5 });

  const technology = [
    {
      id: 1,
      image: html,
      title: "HTML 5",
      backContent:
        "The standard markup language for creating and structuring content on the web.",
      backColor: "#E44D26",
    },
    {
      id: 2,
      image: css,
      title: "CSS 3",
      backContent:
        "The latest version of CSS used to style and layout web pages with advanced visual effects.",
      backColor: "#61dafb",
    },
    {
      id: 3,
      image: javascript,
      title: "JavaScript",
      backContent:
        "A programming language that enables interactive and dynamic content on websites.",
      backColor: "#8B8000",
    },
    {
      id: 4,
      image: java,
      title: "Java",
      backContent:
        "Programming language with fewer implementation dependencies",
      backColor: "#FF930E",
    },
    {
      id: 5,
      image: react,
      title: "React",
      backContent: "A JavaScript library for building user interfaces",
      backColor: "#2196F3",
    },
    {
      id: 6,
      image: node,
      title: "NodeJS",
      backContent: "High performance backend Javascript code.",
      backColor: "#178B17",
    },
    {
      id: 7,
      image: mongo,
      title: "Mongo DB",
      backContent:
        "Harness the power of your data by building and managing your data in the cloud.",
      backColor: "#13AA52",
    },
    {
      id: 8,
      image: aws,
      title: "AWS",
      backContent: "One of the most powerful cloud platforms.",
      backColor: "#FF9900",
    },
    {
      id: 9,
      image: kotlin,
      title: "Kotlin",
      backContent:
        "A modern, concise, and safe programming language used primarily for Android app development.",
      backColor: "#2D8AD8",
    },
    {
      id: 10,
      image: android,
      title: "Android App",
      backContent:
        "An open-source mobile operating system developed by Google for smartphones and tablets.",
      backColor: "#13AA52",
    },
    {
      id: 11,
      image: photoshop,
      title: "Photoshop",
      backContent:
        "A powerful image editing and graphic design software used for creating and enhancing visuals.",
      backColor: "#3571A3",
    },
    {
      id: 12,
      image: figma,
      title: "Figma",
      backContent:
        "A collaborative UI/UX design tool used for creating wireframes, prototypes, and user interfaces.",
      backColor: "#FF7361",
    },
  ];

  return (
    <>
      <div className="container about-div margin-top">
        <Row className=" position-relative ">
          {/* <div className="section-title">
            <h2 className="title-background">About Us</h2>
            <h2 className="title-foreground">About Us</h2>
          </div> */}
          <div className="text-center">
            <h2 className="bold-text ">About Us</h2>
            <h6 className="subtitle">Who We Are & What Drives Us</h6>
          </div>
          {/* <h1 className="text-center">About Us</h1> */}
          <div className="d-flex align-items-center justify-content-between flex-wrap mt-5 gap-5 gap-md-4 gap-sm-0 ">
            {/* <Col className="d-flex"lg={6} md={6}>
              <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, ease: "easeOut" }}
              >
                <div>
                  <img
                    src={about}
                    alt=""
                    className="img1"
                    style={{ height: "335px", width: "255px" }}
                  />
                </div>
              </motion.div>
              <motion.div
                initial={{ opacity: 0, x: 100 }} // starts 100px right
                animate={{ opacity: 1, x: 0 }} // animates to original position
                transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
              >
                <div>
                  <img
                    src={about1}
                    alt=""
                    className="img2"
                    style={{ height: "330px", width: "255px" }}
                  />
                </div>
              </motion.div>
            </Col> */}
            <Col lg={5} md={12} sm={12} className="img-main">
              <div className="position-relative d-flex justify-content-center justify-content-md-center justify-content-sm-start" ref={aboutImagesRef}>
                {/* <img
                    src={about3}
                    className="img1"
                    alt=""
                    style={{ height: "380px" }}
                  />
                  <img
                    className="position-absolute img2"
                    src={about4}
                    alt=""
                    style={{ height: "180px" }}
                  /> */}
                <motion.img
                  src={about3}
                  alt=""
                  className="img1"
                  style={{ height: "315px" }}
                  initial={{ x: -200, opacity: 0 }}
                  animate={
                    aboutImagesInView
                      ? { x: 0, opacity: 1 }
                      : { x: -200, opacity: 0 }
                  }
                  transition={{ duration: 1.5, ease: "easeOut" }}
                />

                <motion.img
                  src={about4}
                  alt=""
                  className="position-absolute img2"
                  style={{ height: "170px" }}
                  initial={{ x: 200, opacity: 0 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ duration: 1.5, ease: "easeOut", delay: 0.5 }}
                />
                <div className="square"></div>
                <div className="circle"></div>
                <div className="circle2"></div>
              </div>
            </Col>
            <Col lg={5} md={12} sm={12} className="mt-md-5 p-4 p-sm-0">
              <motion.div
                initial={{ scale: 0.9, opacity: 0 }}
                animate={
                  aboutTextInView
                    ? { scale: 1, opacity: 1 }
                    : { scale: 0.9, opacity: 0 }
                }
                transition={{ duration: 0.7 }}
                ref={aboutTextRef}
              >
                <h3 className="mb-4 title">Crafting Digital Excellence</h3>
                <p className="p1 ">
                  Specializing in mobile app development, web development, and
                  web design, we blend creativity, strategy, and technology to
                  deliver results that exceed expectations.
                </p>
                <p className="p1">
                  With a team of experienced developers, designers, and tech
                  enthusiasts, we work closely with our clients to understand
                  their unique needs and transform their ideas into powerful
                  digital products.
                </p>
              </motion.div>
            </Col>
          </div>
        </Row>
      </div>
      <div className="container sevices-div">
        {/* <div className=" mt-5">
            <div className="section-title">
              <h2 className="title-background">Our Services</h2>
              <h2 className="title-foreground">Our Services</h2>
            </div>
          </div> */}
        <div className="text-center margin-top service-top">
          <h2 className="bold-text ">Our Services</h2>
          <h6 className="subtitle">Innovative Services Tailored to Your Needs</h6>
        </div>
        {/* <Row className="mt-5 card-div">
          <Col lg={4} md={6} sm={12}>
            <Card className="card card1">
              <Card.Body>
                <div  className="card-1img">
                  <WebIcon style={{height:"50px",  fill: "#4DAEDE", zIndex: 1 ,stroke:"#4DAEDE",strokeWidth: 1}}/>
                </div>
                <h4 className="fw-bold mt-3">Web Development</h4>
                <p>
                  We build fast, secure, and scalable websites tailored to your
                  business needs. From responsive layouts to dynamic
                  functionality, our development ensures performance across all
                  devices.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <Card className="card card2">
              <Card.Body>
                <div  className="card-2img">
              <MobileIcon style={{height:"50px", fill:"#ff930e", zIndex: 1, stroke:"#ff930e",strokeWidth: 1}}/>
              </div>
                <h4 className="fw-bold mt-3">Mobile App Developmnet</h4>
                <p>
                  From idea to launch, we develop powerful mobile apps for iOS
                  and Android. Our apps are feature-rich, user-centric, and
                  built for performance and scalability.
                </p>
              </Card.Body>
            </Card>
          </Col>
          <Col lg={4} md={6} sm={12}>
            <Card className="card card3">
              <Card.Body>
                <div className="card-3img">
                  <DesignIcon style={{height:"50px", fill:"green", stroke:"green", zIndex: 1,strokeWidth: 7}}/>
                </div>
                <h4 className="fw-bold mt-3">Web Design</h4>
                <p>
                  Our creative team crafts modern, user-friendly designs that
                  capture attention and enhance user experience. We focus on
                  clean aesthetics, intuitive navigation, and responsive
                  layouts.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row> */}
        <Row className="mt-5 card-div" ref={servicesRef}>
          {[1, 2, 3].map((item, i) => (
            <Col lg={4} md={6} sm={12} key={i} className="mb-5">
              <motion.div
                custom={i}
                initial="hidden"
                animate={servicesInView ? "visible" : "hidden"}
                variants={cardVariant}
              >
                <Card className={`card service-card card${item}`} onClick={()=>{navigate("/services")}}>
                  <Card.Body>
                    <div className={`card-${item}img`}>
                      {item === 1 && (
                        <WebIcon
                          style={{
                            height: "50px",
                            fill: "#43b3ea",
                            stroke: "#43b3ea",
                            strokeWidth: 1,
                            zIndex: 1,
                          }}
                        />
                      )}
                      {item === 2 && (
                        <MobileIcon
                          style={{
                            height: "50px",
                            fill: "#ff6a0e",
                            stroke: "#ff6a0e",
                            strokeWidth: 1,
                            zIndex: 1,
                          }}
                        />
                      )}
                      {item === 3 && (
                        <DesignIcon
                          style={{
                            height: "50px",
                            fill: "#36aa36",
                            stroke: "#36aa36",
                            strokeWidth: 7,
                            zIndex: 1,
                          }}
                        />
                      )}
                    </div>
                    <h4 className="bold-text mt-3">
                      {item === 1 && "Web Development"}
                      {item === 2 && "Mobile App Development"}
                      {item === 3 && "Web Design"}
                    </h4>
                    <p>
                      {item === 1 &&
                        "We build fast, secure, and scalable websites tailored to your business needs. From responsive layouts to dynamic functionality, our development ensures performance across all devices."}
                      {item === 2 &&
                        "From idea to launch, we develop powerful mobile apps for iOS and Android. Our apps are feature-rich, user-centric, and built for performance and scalability."}
                      {item === 3 &&
                        "Our creative team crafts modern, user-friendly designs that capture attention and enhance user experience. We focus on clean aesthetics, intuitive navigation, and responsive layouts."}
                    </p>
                  </Card.Body>
                </Card>
              </motion.div>
            </Col>
          ))}
        </Row>
      </div>
      <div
        className="contenct-div text-center d-flex justify-content-center align-items-center"
        ref={contactRef}
      >
        <Row>
          <Col>
            <motion.div
              initial={{ y: 50, opacity: 0 }}
              animate={
                contactInView ? { y: 0, opacity: 1 } : { y: 50, opacity: 0 }
              }
              transition={{ duration: 0.8 }}
            >
              <h2 className="info" style={{ color: "white" }}>
                Grow with Flora infotech to reach new technological heights
              </h2>
              <Button className="contact-btn mt-3" onClick={()=>{navigate("contact")}}>Let's Talk</Button>
            </motion.div>
          </Col>
        </Row>
      </div>
      <div className="container tech-div margin-top" ref={techRef}>
        <div className="text-center mt-4">
          <h2 className="bold-text ">Our Technology</h2>
          <h6 className="subtitle">Powering Solutions with the Latest Tech Stack</h6>
        </div>
        <div className="mt-5">
          <Row>
            {technology.map((item, i) => (
              <Col lg={3} md={4} sm={6} xs={12}  key={i} className="mb-5">
                {/* <Card className="tech-card">
                  <Card.Body>
                    <img src={item.image} alt="" style={{ height: "60px" }} />
                    <h5 className="fw-bold mt-3">{item.title}</h5>
                  </Card.Body>
                </Card> */}
                <motion.div
                  custom={i}
                  initial="hidden"
                  animate={tchInView ? "visible" : "hidden"}
                  variants={cardVariant2}
                  // viewport={{ once: false, amount: 0.1 }}
                 whileInView="visible"
                >
                  <div className="flip-card">
                    <div className="flip-card-inner">
                      <div className="flip-card-front">
                        <Card className="tech-card h-100">
                          <Card.Body className="d-flex flex-column align-items-center justify-content-center">
                            <img
                              src={item.image}
                              alt=""
                              style={{ height: "60px" }}
                            />
                            <h5 className="bold-text mt-2">{item.title}</h5>
                          </Card.Body>
                        </Card>
                      </div>

                      <div
                        className="flip-card-back d-flex align-items-center justify-content-center p-3"
                        style={{ backgroundColor: item.backColor }}
                      >
                        <p className="text-center mb-0 card-text back-text">
                          {item.backContent}
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>
      </div>
      <div className="container mb-5 margin-top"  ref={missonRef}>
        <div className="text-center ">
          <h2 className="fw-bold ">Our Mission</h2>
          <h6 className="subtitle">Transforming Ideas into Digital Reality</h6>
        </div>
        <Row className="d-flex justify-content-between align-items-center mt-5 gap-3 gap-md-3 gap-sm-0 ">
          <Col lg={5} md={12} sm={12}>
            <motion.div
              initial={{ x: -200, opacity: 0 }}
              animate={
                missionInView ? { x: 0, opacity: 1 } : { x: -200, opacity: 0 }
              }
              transition={{ duration: 1.5, ease: "easeOut" }}
            >
              <img className="missionimg" src={mission} alt="" style={{ height: "400px" }} />
            </motion.div>
          </Col>
          <Col lg={5} md={12} sm={12}>
            <motion.div
              initial={{ x: 200, opacity: 0 }}
              animate={missionInView?{ x: 0, opacity: 1 }:{}}
              transition={{ duration: 1, ease: "easeOut", delay: 0.3 }}
            >
              <h3 className="mb-4 title">Your Digital Growth Partner</h3>
              <p className="p1">
                Our Vision is to satisfy our clients with effective work and
                digital solutions. Our vision is to provide service to humanity
                with the help of technologies and artificial intelligence. We
                will always try to complete our work on time, which will make
                you more easy to work with us.
              </p>
            </motion.div>
            <motion.div
              initial={{ x: 200, opacity: 0 }}
              animate={missionInView?{ x: 0, opacity: 1 }:{}}
              transition={{ duration: 2, ease: "easeOut", delay: 1 }}
            >
              <p className="p1">
                Our vision is to work with all type of industries which requires
                a Digital IT Solutions. We can join with all types of business
                persons who are going to innovate their business with internet
                solutions.
              </p>
            </motion.div>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Homecontent;
